// extracted by mini-css-extract-plugin
export default {"loadIcon":"TaskStatusIcon__loadIcon___CXWbE","loadRotate":"TaskStatusIcon__loadRotate___SlDL6"};